import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddEditClientPopupComponent } from './add-edit-client-popup/add-edit-client-popup.component';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DropdownModule } from 'primeng/dropdown';
import { CheckboxModule } from 'primeng/checkbox';
import { InputSwitchModule } from 'primeng/inputswitch';
import { EditorModule } from 'primeng/editor';
import { FileUploadModule } from 'primeng/fileupload';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputTextModule } from 'primeng/inputtext';
import { DividerModule } from 'primeng/divider';
import { NgxColorsModule } from 'ngx-colors';
import { CalendarModule } from 'primeng/calendar';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputNumberModule } from 'primeng/inputnumber';
import { ActionLogComponent } from './action-log/action-log.component';
import { PaginatorModule } from 'primeng/paginator';
import { SkeletonModule } from 'primeng/skeleton';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { TooltipModule } from 'primeng/tooltip';
import { AddEditPagesSkeletonComponent } from './add-edit-pages-skeleton/add-edit-pages-skeleton.component';
import { AddEditUserPageSkeletonComponent } from './add-edit-user-page-skeleton/add-edit-user-page-skeleton.component';
import { ClientProfileTabsSkeletonComponent } from './client-profile-tabs-skeleton/client-profile-tabs-skeleton.component';
import { SearchLocationWidgetComponent } from './search-location-widget/search-location-widget.component';
import { AttachmentsJobComponent } from '../job/attachments-job/attachments-job.component';
import { ToastModule } from 'primeng/toast';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { FileIconsModule } from 'ngx-file-icons';
import { AddEditClientPopupForLeadComponent } from './add-edit-client-popup-for-lead/add-edit-client-popup-for-lead.component';
import { EditRecurringJobPopupComponent } from './edit-recurring-job-popup/edit-recurring-job-popup.component';
import { RippleModule } from 'primeng/ripple';
import { AddEditTaskPopupComponent } from './add-edit-task-popup/add-edit-task-popup.component';
import { RouterLink } from '@angular/router';
import { TagModule } from 'primeng/tag';
import { AddEditInventoryPopupComponent } from './add-edit-inventory-popup/add-edit-inventory-popup.component';
import { AddEditItemPopupComponent } from './add-edit-item-popup/add-edit-item-popup.component';
import { MenuModule } from 'primeng/menu';
import { HoverTooltipComponent } from './hover-tooltip/hover-tooltip.component';
import {
  HasAnyPermissionDirective,
  HasPermissionDirective,
} from '../../../core/directives/has-permission.directive';
import { AcanPermissionDirective } from '../../../core/directives/acan-permission.directive';
import { ButtonModule } from 'primeng/button';
import { ConfirmLinkedRecordsDialogComponent } from './revamp/confirm-linked-records-dialog/confirm-linked-records-dialog.component';
import { ListBulkToolbarComponent } from './revamp/list-bulk-toolbar/list-bulk-toolbar.component';
import { PipelineFormRedirectComponent } from './pipeline-form-redirect/pipeline-form-redirect.component';
import { AcanUiModule } from './components/acan-ui.module';
import { FormKitModule } from './form-kit/form-kit.module';
import { ClientFormComponent } from './client-form/client-form.component';
import { ListKitModule } from './revamp/list-kit/list-kit.module';
import { DetailKitModule } from './revamp/detail-kit/detail-kit.module';
import { RangeKitModule } from './revamp/range-kit/range-kit.module';
import { DropZoneModule } from './revamp/drop-zone/drop-zone.module';
import { GstTreatmentSelectModule } from './revamp/gst-treatment-select/gst-treatment-select.module';
import { JobLabelModule } from './revamp/job-label/job-label.module';
import { RecordNoPipe } from '../pipeline/shared/record-no.pipe';

@NgModule({
  declarations: [
    HoverTooltipComponent,
    AddEditTaskPopupComponent,
    AddEditClientPopupComponent,
    ActionLogComponent,
    AddEditPagesSkeletonComponent,
    AddEditUserPageSkeletonComponent,
    ClientProfileTabsSkeletonComponent,
    SearchLocationWidgetComponent,
    AttachmentsJobComponent,
    AddEditClientPopupForLeadComponent,
    EditRecurringJobPopupComponent,
    AddEditTaskPopupComponent,
    AddEditInventoryPopupComponent,
    AddEditItemPopupComponent,
    ConfirmLinkedRecordsDialogComponent,
    ListBulkToolbarComponent,
    PipelineFormRedirectComponent,
    ClientFormComponent,
  ],
  imports: [
    CommonModule,
    DialogModule,
    ConfirmDialogModule,
    DropdownModule,
    CheckboxModule,
    InputSwitchModule,
    EditorModule,
    FileUploadModule,
    ReactiveFormsModule,
    FormsModule,
    InputTextareaModule,
    InputTextModule,
    DividerModule,
    NgxColorsModule,
    CalendarModule,
    MultiSelectModule,
    InputNumberModule,
    PaginatorModule,
    SkeletonModule,
    GooglePlaceModule,
    TooltipModule,
    ToastModule,
    ConfirmPopupModule,
    FileIconsModule,
    RippleModule,
    RouterLink,
    TagModule,
    MenuModule,
    HasPermissionDirective,
    HasAnyPermissionDirective,
    AcanPermissionDirective,
    ButtonModule,
    AcanUiModule,
    FormKitModule,
    ListKitModule,
    DetailKitModule,
    RangeKitModule,
    DropZoneModule,
    GstTreatmentSelectModule,
    JobLabelModule,
    RecordNoPipe,
  ],
  exports: [
    ClientFormComponent,
    FormKitModule,
    HoverTooltipComponent,
    AddEditClientPopupComponent,
    ActionLogComponent,
    AddEditPagesSkeletonComponent,
    AddEditUserPageSkeletonComponent,
    SearchLocationWidgetComponent,
    AttachmentsJobComponent,
    AddEditClientPopupForLeadComponent,
    EditRecurringJobPopupComponent,
    AddEditTaskPopupComponent,
    AddEditInventoryPopupComponent,
    ConfirmLinkedRecordsDialogComponent,
    ListBulkToolbarComponent,
    PipelineFormRedirectComponent,
    HasPermissionDirective,
    HasAnyPermissionDirective,
    AcanPermissionDirective,
    AcanUiModule,
    ListKitModule,
    DetailKitModule,
    RangeKitModule,
    DropZoneModule,
    GstTreatmentSelectModule,
    JobLabelModule,
    RecordNoPipe,
  ],
})
export class SharedModule {}
